import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../wpconfig"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink} from "@fortawesome/free-solid-svg-icons";

class RelationItem extends Component {
	constructor(props) {
		super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record: r,
			field: 'journal_relation',
			name: '아이디',
			id: 'relation_journal_id'
		}
	}

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, false);
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.props.record[this.props.pkKey]) {
				func.updateData("admin/" + this.state.field + "/" + func.getParams("record_id") + "/update", this.props.record).then((response) => {
					console.log(response)
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							record: JSON.parse(JSON.stringify(this.props.record))
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = this.props.record;
				if (this.relation_journal_id.value === '') {
					this.relation_journal_id.focus();
				} else if (this.relation_journal_title.value === '') {
					this.relation_journal_title.focus();
				} else {
					delete record.is_edit;
					func.updateData("admin/" + this.state.field + "/" + func.getParams("record_id") + "/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (event) => {
		event.preventDefault()

		const record = this.props.record;
		if (record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.props.onUpdate(this.props.arrIndex, this.state.record, true);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm(record[this.state.id] + ' ' + this.state.name + '를 ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("admin/" + this.state.field + "/" + func.getParams("record_id") + "/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	// onEdit = (e) => {
	// 	this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
	// };

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	};

	render() {
		const record = this.props.record;

		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr className="list-row">
						<td className="column-id-type">
							<label className="mt-2">{this.props.categoryName[record.journalrelation_type]}</label>
						</td>
						<td className="column-id-value">
							<label className="mt-2">{record.relation_journal_id}</label>
						</td>
						<td className="column-id-value">
							<label className="mt-2">{record.relation_journal_title}</label>
						</td>
						<td className="column-action">
							<button className="btn btn-outline-info btn-sm insert mr-1"
							        onClick={this.onEditSave}>{record[this.props.pkKey] ? '편집' : '저장'}</button>
							<button className="btn btn-outline-dark btn-sm cancel" onClick={this.onCloseDelete}>삭제</button>
							<button type="button" className="btn btn-outline-secondary btn-sm ml-1">
								<FontAwesomeIcon icon={faLink}/>
							</button>
						</td>
					</tr>
					:
					<tr className="list-row">
						<td>
							<select className="form-control form-control-sm"
							        defaultValue={record.journalrelation_type}
							        name="type"
							        onChange={this.change}>
								{this.props.category.map((type, i) => {
									return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
								})}
							</select>
						</td>
						<td>
							<input type="text" name="relation_journal_id"
							       ref={(ref) => this.relation_journal_id = ref}
							       className="form-control-sm large-text" defaultValue={record.relation_journal_id}
										 placeholder="아이디를 입력해주세요."
							       onKeyUp={this.change}/>
						</td>
						<td>
							<input type="text" name="relation_journal_title"
							       ref={(ref) => this.relation_journal_title = ref}
							       className="form-control-sm large-text" defaultValue={record.relation_journal_title}
										 placeholder="저널명을 입력해주세요."
							       onKeyUp={this.change}/>
						</td>
						<td>
							{record[this.props.pkKey] ?
								<button href="#" className="btn btn-outline-info btn-sm insert mr-1"
								        onClick={this.onEditSave}>수정</button>
								:
								<button href="#" className="btn btn-outline-info btn-sm insert mr-1"
								        onClick={this.onEditSave}>저장</button>
							}
							<button className="btn btn-outline-dark btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
						</td>
					</tr>
				}
			</>
		)
	}
}

export default RelationItem;